import { CustomModal } from 'CustomComponentCss';
import { FC, useContext, useState } from 'react';
import Button from 'components/atoms/Button';
import { Switch } from 'antd';
import RangeSlider from './RangeSlider';
import { fetchCurrency, formatNumWithKMBAlt, getConfig } from 'utils/helperMethods';
import { UserContext } from 'contexts/ConfigContext';
import _ from 'lodash';
import styled from '@emotion/styled';
import { colorConstants } from 'config/colorConstants';
import { trackEventMixpanel } from 'utils/mixpanel';
import {
    PRICE_POINT_REDEFINE_THRESHOLD_APPLY_CLICKED,
    PRICE_POINT_REDEFINE_THRESHOLD_CUSTOM_THRESHOLD_ADD_MORE_CLICKED,
    PRICE_POINT_REDEFINE_THRESHOLD_CUSTOM_THRESHOLD_CHANGED,
    PRICE_POINT_REDEFINE_THRESHOLD_RESET_CLICKED,
    PRICE_POINT_REDEFINE_THRESHOLD_SCALE_CHANGED,
    PRICE_POINT_REDEFINE_THRESHOLD_SLIDER_CHANGED,
    PRICE_POINT_REDEFINE_THRESHOLD_TOGGLED,
} from 'utils/mixpanelEventNames';

const pricePointTableId = 'price-point-table-wrapper';

export const CustomSwitch = styled(Switch)`
    &.ant-switch-checked {
        background-color: ${colorConstants.violet};
    }
`;

interface Props {
    setShowThreshold: Function;
    showThreshold: boolean;
    tiles: any;
    setTiles: any;
    priceRange: null | [number, number];
    defaultPriceRange: null | [number, number];
    setPriceRange: Function;
    batchSize: number;
    setBatchSize: Function;
    onApplyButton: Function;
    switchValue: boolean;
    setSwitchValue: Function;
    subTileState: any;
}
const Threshold: FC<Props> = ({
    setShowThreshold,
    showThreshold,
    tiles,
    setTiles,
    priceRange,
    setPriceRange,
    batchSize,
    setBatchSize,
    onApplyButton,
    switchValue,
    setSwitchValue,
    defaultPriceRange,
    subTileState,
}) => {
    const [showTiles, setShowTiles] = useState(false);
    const { appConfig } = useContext(UserContext);
    const pricePointConfig = getConfig('pricePoint', appConfig);
    const defaultRange: any = defaultPriceRange?.[subTileState?.key];
    const commonConfig = getConfig('commonConfig', appConfig);
    const handleSwitchChange = () => {
        let isEnabled = false;
        setSwitchValue((prev: boolean) => {
            isEnabled = !prev;
            return !prev;
        });
        setShowTiles((prev) => !prev);
        //mixpanel event
        trackEventMixpanel(PRICE_POINT_REDEFINE_THRESHOLD_TOGGLED, {
            isEnabled,
        });
    };

    function onThresholdChange(e: any, item: any) {
        setTiles((prev: any) => {
            const updatedtiles = _.cloneDeep(prev);

            const indexToEdit = updatedtiles.findIndex((updatedtile: any) => updatedtile.id === item.id);

            if (indexToEdit !== -1) {
                updatedtiles[indexToEdit].value = e.target.value;
            }
            //mixpanel event
            trackEventMixpanel(PRICE_POINT_REDEFINE_THRESHOLD_CUSTOM_THRESHOLD_CHANGED, {
                thresholdIndex: item?.id,
                thresholdValue: e.target.value,
            });
            return updatedtiles;
        });
    }
    const handleChangeStep = (e: any) => {
        setBatchSize(e.target.value);
        //mixpanel event
        trackEventMixpanel(PRICE_POINT_REDEFINE_THRESHOLD_SCALE_CHANGED, {
            scaleValue: e.target.value,
        });
    };
    function addNewTilesHandler(e: any) {
        if (showTiles) {
            setTiles((prev: any) => {
                const newval = {
                    id: tiles.length + 1,
                    value: '',
                };
                return [...prev, newval];
            });
            //mixpanel event
            trackEventMixpanel(PRICE_POINT_REDEFINE_THRESHOLD_CUSTOM_THRESHOLD_ADD_MORE_CLICKED);
        } else {
            setShowTiles(true);
        }
    }
    function onResetButton() {
        setTiles([...pricePointConfig.customThresholdData]);
        setPriceRange(defaultRange);
        setBatchSize(1);
        //mixpanel event
        trackEventMixpanel(PRICE_POINT_REDEFINE_THRESHOLD_RESET_CLICKED);
    }
    function onApplyButtonClick() {
        onApplyButton();
        setShowTiles(false);
        setShowThreshold(false);
        //mixpanel event
        trackEventMixpanel(PRICE_POINT_REDEFINE_THRESHOLD_APPLY_CLICKED);
    }

    function onSliderChange(val: any) {
        setPriceRange(val);
        //mixpanel event
        trackEventMixpanel(PRICE_POINT_REDEFINE_THRESHOLD_SLIDER_CHANGED, {
            sliderValue: val,
        });
    }

    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                <Button title={'Reset'} onClick={() => onResetButton()} style={{ padding: '0px 20px' }} />
                <Button
                    title={'Apply'}
                    onClick={() => onApplyButtonClick()}
                    theme={'Solid'}
                    style={{ padding: '0px 20px' }}
                />
            </div>
        );
    };
    const handleCancel = () => {
        setShowThreshold(false);
    };
    const currency = fetchCurrency(appConfig);
    return (
        <CustomModal
            title={'Redefine Threshold'}
            open={showThreshold}
            width={427}
            onCancel={handleCancel}
            centered
            maskClosable={false}
            footer={Footer()}
        >
            <div style={{ opacity: switchValue ? 0.3 : 1 }} className="flex w-full justify-between px-3 py-3">
                <div className="">
                    <div>Slider Range</div>
                    <RangeSlider
                        disabled={switchValue}
                        min={defaultRange?.[0]}
                        max={defaultRange?.[1]}
                        defaultValue={defaultRange}
                        minMaxValue={priceRange}
                        setMinMaxValue={onSliderChange}
                    />
                    <div className="flex w-full justify-between">
                        <div>
                            {currency}
                            {formatNumWithKMBAlt(defaultRange?.[0], 2, 2)}
                        </div>
                        <div>
                            {currency}
                            {formatNumWithKMBAlt(defaultRange?.[1], 2, 2)}
                        </div>
                    </div>
                </div>
                <div>
                    <div className="flex w-full justify-between flex-col">Scale</div>
                    <input
                        disabled={switchValue}
                        type="number"
                        value={batchSize}
                        onChange={handleChangeStep}
                        placeholder={`Enter Threshold`}
                        className="border border-purpleFont rounded px-3 py-3 relative bg-white bg-white rounded text-base border-0 outline-none w-full pl-5 h-5 mb-0.5"
                    />
                </div>
            </div>
            <div className="flex w-full justify-between">
                <span className="font-lg text-headerColor font-medium pl-4">Custom Thresholds</span>
                <span className=" mr-3">
                    <CustomSwitch className="pr-16" checked={switchValue} onChange={handleSwitchChange} />
                </span>
            </div>
            <div
                style={{ opacity: !switchValue ? 0.3 : 1 }}
                className="flex w-full max-h-[285px] overflow-y-auto justify-between flex-col"
            >
                {tiles.map((data: any, idx: number) => {
                    return (
                        <div className="flex justify-between w-full items-center border-solid border-0 border-t border-borderGrey p-3 !text-fontGray">
                            <div className="font-xxs !text-fontGray w-28 min-w-40 font-medium">
                                Threshold {idx + 1} ({commonConfig?.units?.currency})
                            </div>

                            <div className="flex flex-col">
                                <span className="border border-purpleFont rounded">
                                    <input
                                        disabled={!switchValue}
                                        type="number"
                                        value={data.value}
                                        onChange={(e) => onThresholdChange(e, data)}
                                        placeholder={`Enter Threshold`}
                                        className="px-3 py-3 relative bg-white bg-white rounded text-base border-0 outline-none w-full pl-5 h-5 pt-4 mb-0.5"
                                    />
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>

            <button
                style={{ opacity: !switchValue ? 0.3 : 1 }}
                disabled={!switchValue}
                className="flex w-full justify-between flex-col pl-4"
                onClick={addNewTilesHandler}
            >
                + Add more
            </button>
        </CustomModal>
    );
};

export default Threshold;
